/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import React, { useEffect } from "react";
import { authCheckCallApi } from "../Authenticator/utils";
import { UserQuery } from "../../graphql/user";
import { useApolloClient } from "@apollo/react-hooks";

declare global {
  interface Window {
    pmaMenuLoadProfileImage: any;
  }
}

interface MenuProps {
  userId: string;
}

const setCookie = (name: string, value: string) => {
  const date = new Date();
  date.setDate(date.getDate() + 1);
  document.cookie = `${name}=${encodeURIComponent(value)};domain=${
    process.env.REACT_APP_AWS_COOKIE_DOMAIN
  };expires=${date.toUTCString()};samesite=strict`;
};

const unsetCookie = (name: string) => {
  document.cookie = `${name}=;domain=${process.env.REACT_APP_AWS_COOKIE_DOMAIN};expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};

export const setMenuProfileImage = (imageUrl: string) => {
  setCookie("pmaProfileImage", imageUrl);
  window.pmaMenuLoadProfileImage && window.pmaMenuLoadProfileImage(imageUrl);
};

const Menu: React.FC<MenuProps> = ({ userId }) => {

  const getScript = (url: string) => {
    const script = document.createElement("script");
    script.src = url;
    script.async = true;
    script.id = "ProtectMyAppMenu";
    return script;
  };

  const getMenuUrl = () => {
    const portalHostname = window.location.hostname;
    const isLocal = portalHostname.includes("local.");
    return `${window.location.protocol}//${portalHostname}${
      isLocal ? ":3000" : ""
    }/menu/menu.js`;
  };

  const client = useApolloClient();

  useEffect(() => {
    const getUser = () => {
      authCheckCallApi(() => {
        client
          .query({
            fetchPolicy: "no-cache",
            query: UserQuery,
            variables: { userId },
          })
          .then((result) => {
            setMenuProfileImage(result?.data?.user?.imageUrl || "default");
          })
          .catch(() => {});
      });
    };

    const portalMenu = getScript(getMenuUrl());
    if (window.location.pathname !== "/Logout") {
      document.head.appendChild(portalMenu);
      getUser();
    } else {
      unsetCookie("pmaProfileImage");
      unsetCookie("pmaAnalytics");
    }
  }, [client, userId]);

  return null;
};

export default Menu;
